module.exports = window.top.once;